import React from 'react';
import UpdateAccountComponent from './update-account.component';

function UpdateAccount() {
    return <UpdateAccountComponent />;
}

export default UpdateAccount;
